import ServerHome from "../../ServerHome/ServerHome";

export default function ServerPredictHome(store) {
  return (
    <ServerHome
      title="Select Your Protein Task!"
      descriptions={[
        "ACPred-FL: a sequence-based predictor using effective feature representation to improve the prediction of anti-cancer peptides.",
        "PEPred-Suite: improved and robust prediction of therapeutic peptides using adaptive feature representation learning.",
        "PepBCL: a novel BERT-based contrastive learning framework to predict the protein-peptide binding residues based on protein sequences only.",
        "MEDICO: a Multi-viEw Deep generative model for molecule generation, structural optimization, and the SARS-CoV-2 Inhibitor disCOvery.",
      ]}
    />
  );
}
